<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{ tituloGrids }}</span>
      </v-col>
      <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs class="py-2 px-0" :items="aItemsBreadcrumbs" divider=">">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item class="titlesdark--text">
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <div class="under-sec-flat-gray mt-1">
          <v-slide-group class="pa-1" show-arrows>
            <v-slide-item
              v-for="(itemProgress, idx) in aItemsProgressEstados"
              :key="'itemProgress' + idx"
            >
              <ProgressCircular
                :key="nRefresProgressCircular"
                :progresoTotal="itemProgress.valorTotal"
                :progresoActual="itemProgress.valorActual"
                :titulo="itemProgress.titulo"
                :idEvento="itemProgress.idEvento"
                @filtrar="onFiltrarEstado"
                :class="{ inactivo: bProgessEstado[idx] }"
              />
            </v-slide-item>
          </v-slide-group>
        </div>
        <grid
          v-if="this.$store.state.token != ''"
          :key="nRefreshGestionPqr"
          :tabla="TablaName"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="false"
          :bShowSelect="false"
          :sIdTable="'idRequerimiento'"
          :bShowMapDetails="false"
          :bActiveNew="false"
          :aInfoTBDetalleExp="aDetallesExport"
          @idSelect="getIdSelect"
          @filtrando="onRefrescarItems"
          @nameField="getNameFieldSelect"
          @oItemSeleccionado="getItemSeleccionado"
          @onBtnAgregarObs="onAccionEvento"
          @onBtnEditarSac="onAccionEvento"
          :aParametros.sync="aFiltroParametros"
          :aAccionesAdicionales="aAccionesAdicionales"
        >
        </grid>

        <!-- Editar ticket modal -->
        <EditarTicket ref="rEditarTicket" @onSuccessEdit="onSuccessEdit" />
        <AgregarObservacion
          ref="rAggObservacion"
          @onCerrarAgregar="onCerrarAgregar"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
import grid from "@/components/Grid/Grid.vue";
import mxFunciones from "@/mixins/funciones.js";
import axiosServices from "@/services/axiosServices.js";
import ProgressCircular from "@/components/Seif/riesgos/CircularProgress.vue";
import EditarTicket from "@/views/sac/formularios/EditarTicket.vue";
import AgregarObservacion from "@/views/sac/formularios/AgregarObservacion.vue";
export default {
  name: "MisReportes",
  components: {
    grid,
    ProgressCircular,
    EditarTicket,
    AgregarObservacion,
  },
  mixins: [mxFunciones],
  data() {
    return {
      TablaName: "PQR_Requerimientos", // Nombre de la tabla a trabajar
      nIdSeleccionado: 0, // Id seleccionado
      sNombreCampoFiltro: "", // Nombre del campo foreignKey
      oItemSeleccionado: {},
      nKeyReset: 0,
      aItemsProgressEstados: [], // Valores del progreso
      nRefresProgressCircular: 0,
      aFiltroParametros: [
        `idEstado=1`,
        `sPqrPerfil=${this.$store.state.sIdPqrPerfil}`,
        `sDepcia=${this.$store.state.sDependencias}`,
        `sDepto=${this.$store.state.idDeparment}`,
        `sTipoReq=`,
      ],
      aItemsBreadcrumbs: [
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: true,
          href: "breadcrumbs_dashboard",
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlSac,
          disabled: true,
          href: "breadcrumbs_dashboard",
        },
        {
          text: "",
          disabled: true,
          href: "breadcrumbs_dashboard",
        },
      ],
      aDetallesExport: [],
      bProgessEstado: [],
      nRefreshGestionPqr: 0,
      // Componentes de acciones para la grid
      aAccionesAdicionales: [
        {
          componente: "BtnEditarSAC",
          mensaje: "Editar",
          oProps: {
            sNombre: "editarTicket",
            sTablaFormulario: "PQR_Requerimientos",
            sDetalleTitulo: "Información de ticket",
            bDetalleFormulario: true,
          },
        },
        {
          componente: "BtnAgregarObs",
          mensaje: "Agregar observación",
          oProps: {
            sNombre: "agregarObservacion",
            sTablaFormulario: "PQR_Requerimientos",
            sDetalleTitulo: "Información de Ticket",
            bDetalleFormulario: true,
          },
        },
      ],
    };
  },
  async mounted() {
    this.onValidarTokenSinLogin();
    this.onDescargarEstados();
    this.tituloGrids = await this.getTitulo(this.TablaName);
    this.aItemsBreadcrumbs[2].text = this.tituloGrids;
  },
  methods: {
    async onRefrescarItems(oFiltros = "") {
      const sFiltro =
        oFiltros === undefined || oFiltros === null || oFiltros == ""
          ? ``
          : `filtros=${JSON.stringify(oFiltros)}`;
      this.onDescargarEstados(sFiltro);
    },
    // Aqui se recibe la data que emite el componente EditarTicket al realizar un update correctamente
    onSuccessEdit({ sStatus, sMessage }) {
      this.$swal({
        timer: 1500,
        icon: `${sStatus}`,
        title: `${sMessage}`,
        showConfirmButton: false,
      });
      const rEditar = this.$refs.rEditarTicket;
      rEditar.bMostrar = false;
      this.nRefreshGestionPqr++;
    },
    onCerrarAgregar() {
      const rEditar = this.$refs.rAggObservacion;
      rEditar.bMostrar = false;
      setTimeout(() => {
        this.nRefreshGestionPqr++;
      }, 1000);
    },
    onAccionEvento(oItem, sAccion, oDetalleFormulario) {
      oDetalleFormulario
      // creamos una variable que nos guarda la referencia del componente editar ticket
      const rEditar = this.$refs.rEditarTicket;
      const rAggObservacion = this.$refs.rAggObservacion;
      // capturamos el id del registro
      const { idRequerimiento } = oItem;
      switch (sAccion) {
        // Case para Editar ticket
        case "editarTicket":
          rEditar.bMostrar = true;
          rEditar.idRequerimiento = idRequerimiento;
          // Ejecutamos la función onGetForm del componente EditarTicket
          rEditar.onGetForm();
          break;
        // Case para agregar observacion
        case "agregarObservacion":
          rAggObservacion.bMostrar = true;
          // asignamos el id
          rAggObservacion.idRequerimiento = idRequerimiento;
          rAggObservacion.onInit();
          break;
      }
    },
    onFiltrarEstado(sId) {
      this.bProgessEstado = Array(this.aItemsProgressEstados.length).fill(true);
      this.bFiltroActivo = !this.bFiltroActivo;
      if (sId - 1 >= 0) {
        this.$set(this.bProgessEstado, sId - 1, false);
      } else {
        this.bProgessEstado = Array(this.aItemsProgressEstados.length).fill(
          false
        );
      }
      if (this.bFiltroActivo) {
        this.aFiltroParametros[0] = `idEstado=${Math.abs(sId)}`;
        this.onRefrescarItems();
        this.nRefreshGestionPqr++;
      } else {
        this.aFiltroParametros[0] = `idEstado=1`;
        this.onRefrescarItems();
        this.nRefreshGestionPqr++;
      }
    },
    async onDescargarEstados(sFiltro = "") {
      // prueba
      const state = this.$store.state;
      const sParams = `sPqrPerfil=${state.sIdPqrPerfil}&sDepcia=${state.sDependencias}&sDepto=${state.idDeparment}&sNameTable=${this.TablaName}&${sFiltro}`;
      const { aData } = await axiosServices.getConfiguration(
        "/pqr/estados",
        true,
        sParams
      );
      this.aItemsProgressEstados = aData;
      this.bMostrarModal = false;
    },
    getIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
    getItemSeleccionado(oItemSeleccionado) {
      this.oItemSeleccionado = oItemSeleccionado;
    },
  },
};
</script>
<style lang="scss" scoped>
.inactivo {
  opacity: 0.3;
  pointer-events: none !important;
}
</style>